module.exports = __webpack_public_path__ + "static/media/neutral.fe3f92cb.svg";